import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateRangePicker = ({ startDate, endDate, setStartDate, setEndDate }) => {
  return (
    <>
      <Form>
        <Row >
          <Col xs="auto">
            <Form.Group>
              <Form.Label  className="px-1 fw-bold text-dark">Start Date</Form.Label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                className="form-control"
                dateFormat="yyyy-MM-dd"
                placeholderText="Start Date"
                showTimeSelect={false}
                // isClearable

              />
            </Form.Group>
          </Col>
          <Col xs="auto">
            <Form.Group>
              <Form.Label  className="px-1 fw-bold text-dark">End Date</Form.Label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                dateFormat="yyyy-MM-dd"
                placeholderText="End Date"
                className="form-control"
                showTimeSelect={false}
                // isClearable
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default DateRangePicker;
